import isPropValid from '@emotion/is-prop-valid';
import { styled as muiStyled } from '@mui/material/styles';
/**
 * Custom `styled` wrapper that prevents invalid props from leaking into the DOM.
 * * - **HTML tags (strings):** Filters props using `isPropValid` to ensure only
 * standard HTML attributes are rendered.
 * - **React Components:** Filters out **transient props** (prefixed with `$`).
 * * Use this to avoid "Unknown Prop" console warnings when passing styling logic
 * to your components.
 * * @example <StyledBox $isVisible={true} /> // '$isVisible' is stripped from HTML
 */
const styled = ((component, options) => {
    const customShouldForwardProp = options?.shouldForwardProp;
    if (typeof component === 'string') {
        return muiStyled(component, {
            ...options,
            shouldForwardProp: (prop) => isPropValid(prop) &&
                (customShouldForwardProp ? customShouldForwardProp(prop) : true)
        });
    }
    return muiStyled(component, {
        ...options,
        shouldForwardProp: (prop) => !prop.startsWith('$') &&
            (customShouldForwardProp ? customShouldForwardProp(prop) : true)
    });
});
export { styled };
